import React from 'react';

const TickCircle = (props: object) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.9987 14.6673C11.6654 14.6673 14.6654 11.6673 14.6654 8.00065C14.6654 4.33398 11.6654 1.33398 7.9987 1.33398C4.33203 1.33398 1.33203 4.33398 1.33203 8.00065C1.33203 11.6673 4.33203 14.6673 7.9987 14.6673Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.16797 7.99995L7.05464 9.88661L10.8346 6.11328"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TickCircle;
